/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type { CarrierRequestAudit } from "../models/index";
import {
  CarrierRequestAuditFromJSON,
  CarrierRequestAuditToJSON,
} from "../models/index";

export interface GetAuditsByTrackingLineRequest {
  trackingLineId: string;
}

export interface GetCarrierRequestAuditByIdRequest {
  auditId: string;
}

/**
 *
 */
export class CarrierRequestAuditApi extends runtime.BaseAPI {
  /**
   */
  async getAuditsByTrackingLineRaw(
    requestParameters: GetAuditsByTrackingLineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierRequestAudit>>> {
    if (requestParameters["trackingLineId"] == null) {
      throw new runtime.RequiredError(
        "trackingLineId",
        'Required parameter "trackingLineId" was null or undefined when calling getAuditsByTrackingLine().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["trackingLineId"] != null) {
      queryParameters["trackingLineId"] = requestParameters["trackingLineId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-request-audit/get-audits-by-tracking-line`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierRequestAuditFromJSON),
    );
  }

  /**
   */
  async getAuditsByTrackingLine(
    requestParameters: GetAuditsByTrackingLineRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierRequestAudit>> {
    const response = await this.getAuditsByTrackingLineRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   */
  async getCarrierRequestAuditByIdRaw(
    requestParameters: GetCarrierRequestAuditByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierRequestAudit>>> {
    if (requestParameters["auditId"] == null) {
      throw new runtime.RequiredError(
        "auditId",
        'Required parameter "auditId" was null or undefined when calling getCarrierRequestAuditById().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["auditId"] != null) {
      queryParameters["auditId"] = requestParameters["auditId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-request-audit/get-carrier-request-audit-by-id`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierRequestAuditFromJSON),
    );
  }

  /**
   */
  async getCarrierRequestAuditById(
    requestParameters: GetCarrierRequestAuditByIdRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierRequestAudit>> {
    const response = await this.getCarrierRequestAuditByIdRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
